import { useContext } from 'react';
import CallContext from './CallContext';

const useCall = () => useContext(CallContext);

export default useCall;
